<template>
    <div>
        <b-link v-b-modal.enlarge-picture-modal>
            <ProtectedImage :src="thumbnailSrc" :fallback-url="fallbackUrl" :reload="thumbnailReload" fluid rounded center style="max-height: 250px;" />
        </b-link>
        <b-modal id="enlarge-picture-modal" size="xl" hide-header hide-footer centered @hidden="onModalClosed()">
            <ProtectedImage :src="enlargedSrc" :fallback-url="fallbackUrl" fluid rounded center class="img-large" />
            <div class=overlay>
                <b-row>
                  <b-col class="mt-5">
                    <p class="overlay-text">Cliquez sur l'image actuelle pour en choisir une nouvelle (taille &lt; 5 Mo)</p>
                  </b-col>
                </b-row>
                <b-form-file class="input" v-model="newFilename" @change="onFileChange" plain no-drop accept="image/*" title=" "></b-form-file>
                <b-row class="d-flex justify-content-center">
                  <b-col class="text-right" cols="6">
                    <b-button variant="success" class="overlay-button" @click="saveImage()" >
                      <font-awesome-icon :icon="['fas', 'upload']" />
                      Enregistrer
                    </b-button>
                  </b-col>
                  <b-col class="text-left" cols="6">
                    <b-button variant="danger" class="overlay-button" @click="deleteImage()" >
                      <font-awesome-icon :icon="['fas', 'trash']" />
                      Supprimer
                    </b-button>
                  </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
const axios = require('axios').default;
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ProtectedImage from './ProtectedImage';

export default {
    name: 'ImageDisplayUploader',
    props: {
        hasImg: Boolean,
        fallbackUrl: String,
        endpoint: String
    },
    components: {
      FontAwesomeIcon,
      ProtectedImage
    },
    data: function () {
        return {
          newImg: null,
          newFilename: null,
          thumbnailReload: 0
        }
    },
    computed: {
      thumbnailSrc() {
        return this.hasImg ? this.endpoint : null;
      },
      enlargedSrc() {
        return this.newImg || (this.hasImg ? this.endpoint : null);
      }
    },
    methods: {
      deleteImage() {
        axios.delete(this.endpoint)
          .then(response => {
            this.$emit('has-img-changed', false);
          })
          .catch(error => {
            console.log(error);
          })
      },
      saveImage() {
        if (this.newFilename != null) {
          let data = new FormData();
          data.append('img', this.newFilename);

          let config = {
            header : {
              'Content-Type': 'multipart/form-data'
            }
          }
          axios.put(this.endpoint, data, config)
            .then(response => {
              this.newImg = null;
              this.thumbnailReload++;   //force reload thumbnail
              this.$emit('has-img-changed', true);
            })
            .catch(error => {
              console.log(error);
            })
        }
        
      },
      onFileChange(e) {
        this.newImg = URL.createObjectURL(e.target.files[0]);
      },
      onModalClosed(e) {
        this.newImg = null;
      }
    }
}
</script>


<style scoped>
.img-large {
  display: block;
}

.input {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
}

.overlay {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  transition: .5s ease;
  opacity: 0;
}

.overlay:hover {
  background-color: #000;
  opacity: 0.7;
}

.overlay:hover .overlay-text {
  opacity: 1;
}

.overlay:hover .overlay-button {
  opacity: 1;
}

.overlay-text {
  text-align: center;
  color: #ffffff;
  font-weight: bold;
}
</style>